(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SectionDialogController', SectionDialogController);

    SectionDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'Section', 'Test', 'Question', 'action'];

    function SectionDialogController ($scope, $stateParams, $uibModalInstance, entity, Section, Test, Question, action) {
        var vm = this;
        vm.section = entity;
        vm.tests = Test.query();
        vm.questions = Question.query();
        vm.load = function(id) {
            Section.get({id : id}, function(result) {
                vm.section = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:sectionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.section.id !== null) {
                Section.update(vm.section, onSaveSuccess, onSaveError);
            } else {
                Section.save(vm.section, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
